export function getUserDisplayName(
  displayName: string | null | undefined,
  userId: string,
): string {
  const normalized = displayName?.trim();
  return normalized && normalized.length > 0 ? normalized : userId;
}

export function getUserInitials(
  displayName: string | null | undefined,
  userId: string,
): string {
  const label = getUserDisplayName(displayName, userId).trim();
  if (!label) {
    return "";
  }

  const words = label.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return `${words[0][0] ?? ""}${words[1][0] ?? ""}`.toUpperCase();
  }

  return label.slice(0, 2).toUpperCase();
}
